export const childrenPaths = [
]

export default [
  {
    path: "/admin-panel",
    name: "Admin Panel",
    meta: {
      title: "Admin Panel",
      icon: "bhi-pulse",
      requiresAuth: true
    },
    hidden: true,
    redirect: {
      name: "Admin Panel Logs",
    },
  },
  {
    path: "/admin-panel/logs",
    name: "Admin Panel Logs",
    hidden: true,
    meta: {
      title: "Admin Panel - Logs",
      icon: "bhi-pulse",
      requiresAuth: true
    },
    component: () => import("@/views/adminPanel/AdminPanelLogs.vue"),
  },
  {
    path: "/admin-panel/logs/:id",
    name: "Admin Panel Log View",
    hidden: true,
    meta: {
      title: "Admin Panel - Database Log",
      icon: "bhi-pulse",
      requiresAuth: true
    },
    component: () => import("@/views/adminPanel/AdminPanelLogView.vue"),
  },
]